import { YieldFetcher } from '../../types'

const BEETS_URL = 'https://backend-v3.beets-ftm-node.com/'
const stS = 'Beets Staked Sonic::STS'

export const stsFetcher: YieldFetcher = {
  label: 'STS',
  fetch: async () => {
    const res = await fetch(BEETS_URL, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        operationName: 'GetStakedSonicData',
        query:
          'query GetStakedSonicData { stsGetGqlStakedSonicData { stakingApr } }',
      }),
    }).then((r) => r.json())
    const apr = Number(res.data?.stsGetGqlStakedSonicData?.stakingApr) * 100
    return { [stS]: apr }
  },
}
